import React, { useContext } from 'react';
import PopUpDialogTemplate from './PopUpDialogTemplate';
import { isMobileLandscape } from 'react-device-detect';
import classNames from 'classnames';
import Chips from '../../../Club/ChipBalance/Chips';




const TournamentBonusMessage = ({ amount, onClose, t }) => {
    const BTN_NAMES = {
        confirm: t('ok')
    };

    const bonusDialogMessagesClasses = classNames({
        'popup__dialog__bonus-messsage': true,
        'popup__dialog__bonus-messsage--landscape': isMobileLandscape
    })

    return (
        <div className="tournaments__popup bonus-dialog">
        <div className="tournaments__popup__overlay" />
            <PopUpDialogTemplate className={bonusDialogMessagesClasses} btnNames={BTN_NAMES} onConfirm={onClose}>
                <React.Fragment>
                    {
                    isMobileLandscape ?
                        <div className="bonus__dialog__image-container">
                            <img className="bonus__dialog__image" src="/static/images/bonus-image/bonus-image-landscape.png" alt="Bonus"/>
                        </div>
                    :null
                    }
                    <div className="tournament__bonus__message__container">
                        <h3 className="tournament__bonus__message__title">{t('congrats')}</h3>
                        <h4 className="tournament__bonus__message__subtitle">{t('gotBonus')}</h4>
                        <div className="tournament__bonus__message__coins-wrapper">
                            <Chips val={amount} />
                        </div>
                    </div>
                    <p className="tournament__bonus__message__description">{t('bonusUsage')}</p>
                </React.Fragment>
            </PopUpDialogTemplate>
        </div>
    )
}

export default TournamentBonusMessage;
